// extracted by mini-css-extract-plugin
export default {"container":"AdditionalIncome_container__ZIR5I","skeletonLoadingAnimation":"AdditionalIncome_skeletonLoadingAnimation__Px6IN"};